import { BaseMapper } from 'src/data/common/BaseMapper'
import { ParamsMapper } from 'src/data/common/type'

import { CustomerPdAPI, CustomerPdModel } from './type'

export class CustomerPdMapper extends BaseMapper {
  apiMapper = (pd: CustomerPdAPI): CustomerPdModel => {
    return {
      id: pd.id,
      customer_pd_id: pd.customer_pd,
      state: pd.state,
      date: pd.date,
      date_confirmed: pd.date_confirmed,
      date_voided: pd.date_voided,
      image_url: pd.image_url,
      os: {
        near: pd.os_near_pd,
        far: pd.os_pd,
      },
      od: {
        near: pd.od_near_pd,
        far: pd.od_pd,
      },
    }
  }

  defaultValue: CustomerPdModel = {
    id: 0,
    customer_pd_id: 0,
    state: '',
    date: '',
    date_confirmed: '',
    date_voided: '',
    image_url: '',
    os: {
      near: 0,
      far: 0,
    },
    od: {
      near: 0,
      far: 0,
    },
  }

  getMappedObject(params: ParamsMapper): any {
    return super.getMappedObject(params)
  }
}
